import React, { useRef, useState } from 'react'
import '../../assets/css/App.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { pageTitle, birthday, contactAddress, contentOfInquery, emails, furigana, furiganaName, headName, labels2, name, ourContract, personEmail, personName, personPhoneNo, phoneNo, subscriber } from '../../utils/ToiawaseText'
import '../../assets/css/ToiawaseConfirm.css'
import { useIntl } from 'react-intl'
import { CDP_PUBLIC_URL, REACT_APP_SITE_KEY } from '../../utils/Constants'
import ReCAPTCHA from 'react-google-recaptcha'
import { callSaveAPI } from '../../api/CDPAPI'

const ToiawaseFormConfirmPage = () => {
    document.title = pageTitle
    const location = useLocation()
    const data = location.state
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const intl = useIntl()
    const captchaRef = useRef(null)
    const recapture = async (e) => {
        const token = await captchaRef.current.executeAsync()
        await callSaveAPI('toiawase-submit', { ...data, recaptchaToken: token })
        .then(res => {
            if (res.status === 200) {
                setLoading(false)
                captchaRef.current.reset()
                navigate(`${CDP_PUBLIC_URL}/inquiry/complete`, { state: data })
            } else {
                if (window.confirm(intl.formatMessage({ id: 'submissionError' }))) {
                    navigate(`${CDP_PUBLIC_URL}/inquiry`, { state: data })
                } else {
                    setLoading(false)
                }
            }
          }).catch(() => {
            if (window.confirm(intl.formatMessage({ id: 'submissionError' }))) {
                navigate(`${CDP_PUBLIC_URL}/inquiry`, { state: data })
            } else {
                setLoading(false)
            }
          })
    }
    const handleSubmit = async (e) => {
        window.scrollTo(0, document.body.scrollHeight)
        e.preventDefault()
        recapture()
    }
    const handleBack = () => {
        navigate(`${CDP_PUBLIC_URL}/inquiry`, { state: { formData: data, isBack: true } })
    }
    return (
        < div className="toiawase-input-section-inputdetails">
            <div className="card-container-inputdetails row">
                <h1 className="h1Style01">お問い合わせ</h1>
                <p className="txt-01">下記の内容でよろしいですか？<br></br>
                    間違っている場合は「訂正」ボタンを押して、再入力してください。</p>
                <div className="col-12">
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-12 head1">{headName}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{name}</label>
                        <label htmlFor="inputtext" className="col-sm-3 formMargin p-15">{data.lastNameKanji_1}{data.firstNameKanji_1}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{furigana}</label>
                        <label htmlFor="inputtext" className="col-sm-3 formMargin p-15">{data.lastNameKana_1}{data.firstNameKana_1}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{birthday}</label>
                        {data.birthYear && data.birthMonth && data.birthDate &&
                            <label htmlFor="inputtext" className="col-sm-3 formMargin p-15">
                                <span>{data.calendarType}{data.birthYear}</span>
                                <span>年</span>
                                <span>{data.birthMonth}</span>
                                <span>月</span>
                                <span>{data.birthDate}</span>
                                <span>日</span></label>}
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{contactAddress}</label>
                        <label htmlFor="inputtext" className="col-sm-9 formMargin p-15">{data.contactZipcode1}-{data.contactZipcode2}{data.contactAddress1}{data.contactAddress2}{data.contactAddress3}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{phoneNo}</label>
                        <label htmlFor="inputtext" className="col-sm-3 formMargin p-15">{data.telephone_1}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{emails}</label>
                        <label htmlFor="inputtext" className="col-sm-3 formMargin p-15">{data.emailId_1}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{ourContract}</label>
                        <label htmlFor="inputtext" className="col-sm-9 formMargin p-15">{data.certificateNumberTextInput}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-12 col-form-label1">{labels2}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{personName}</label>
                        <label htmlFor="inputtext" className="col-sm-3 formMargin p-15">{data.lastNameKanji_2}{data.firstNameKanji_2}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{furiganaName}</label>
                        <label htmlFor="inputtext" className="col-sm-3 formMargin p-15">{data.lastNameKana_2}{data.firstNameKana_2}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{subscriber}</label>
                        <label htmlFor="inputtext" className="col-sm-3 formMargin p-15">{data.relationshipWithSubscriber}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{personPhoneNo}</label>
                        <label htmlFor="inputtext" className="col-sm-3 formMargin p-15">{data.telephone_2}</label>
                    </div>
                    <div className="toiawase-form-group-inputdetails row">
                        <label htmlFor="inputtext" className="col-sm-3 col-form-label1">{personEmail}</label>
                        <label htmlFor="inputtext" className="col-sm-3 formMargin p-15">{data.emailId_2}</label>
                    </div>
                </div>
                < div style={{ marginTop: '30px' }}>
                    <div>
                        <div className="col-12">
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-12 head1">{contentOfInquery}</label>
                            </div>
                            <div className="toiawase-form-group-inputdetails row">
                                <label htmlFor="inputtext" className="col-sm-3 col-form-label1">お問い合わせ内容</label>
                                <label htmlFor="inputtext" className="col-sm-9 formMargin p-15" style={{ wordWrap: 'break-word' }}>{data.remarks}</label>
                            </div>
                        </div>
                    </div>
                </div>
                {loading
                ? <div className='spinContainer'>
                      <div className='spin'></div>
                      <span><h2>{intl.formatMessage({ id: 'LoadingMsg' })}</h2></span>
                    </div>
                : <><div className="input-section-inputdetails">
                        <div className="card-container-inputdetails row">
                            <p className="form-btn-012"><input type="submit" value="送信" name="submit" className="btn-submit" onClick={handleSubmit} /></p>
                        </div>
                    </div>
                    < div className="input-section-inputdetails">
                        <div className="card-container-inputdetails row">
                            <p className="form-btn-012"><input type="submit" value="訂正" name="submit" className="btn-submit1" onClick={handleBack} /></p>
                        </div>
                    </div></>
                }
                <ReCAPTCHA sitekey={REACT_APP_SITE_KEY} size='invisible' ref={captchaRef} />
            </div>
        </div>
    )
}

export default ToiawaseFormConfirmPage
